// extracted by mini-css-extract-plugin
export default {"root":"Profile_root__spI41","divider":"Profile_divider__TzGgB"};